'use client';
import { authHref, safeAuthReturn } from '@/shared/lib/auth-return';

import { useActionState, useEffect } from 'react';

import { useToast } from '@/features/toast';
import { Button, Checkbox, MailIcon, TextFiled } from '@/shared';
import {
	consentOfProcessingPersonalDataDocument,
	ofertaDocument,
	orderOfProcessingPersonalDataDocument,
	userAgreementDocument,
} from '@/shared/constants';

import { registerAction } from '../action';

export function RegisterForm({ redirectPath }: { redirectPath?: string } = {}) {
	const { addToast } = useToast();

	const [state, formAction, pending] = useActionState(registerAction, {});

	useEffect(() => {
		if (state.message) {
			addToast('Ошибка', state.message, 'error');
		}
	}, [addToast, state]);

	return (
		<form
			className="flex flex-1 flex-col gap-8 md:flex-grow-0"
			action={formAction}
		>
			<input
				type="hidden"
				name="redirect"
				value={safeAuthReturn(redirectPath) ?? ''}
			/>
			<fieldset className="mb-auto space-y-3">
				<TextFiled
					type="email"
					name="email"
					placeholder="Email"
					autoComplete="email"
					icon={<MailIcon className="size-6" />}
					defaultValue={(state.formData?.get('email') || '') as string}
					size="lg"
					required
				/>
				{/*<TextFiled*/}
				{/*	type="text"*/}
				{/*	placeholder="Промо код"*/}
				{/*	name="promocode"*/}
				{/*	icon={<StarIcon className="size-6" />}*/}
				{/*	defaultValue={(state.formData?.get('promocode') || '') as string}*/}
				{/*	size="lg"*/}
				{/*/>*/}
			</fieldset>

			<fieldset className="space-y-2">
				<Checkbox
					name="confirmPolicy"
					value="true"
					label={
						<>
							Я принимаю условия{' '}
							<a
								href={orderOfProcessingPersonalDataDocument.url}
								className="text-accent hover:underline"
								target="_blank"
							>
								Политики обработки персональных данных
							</a>{' '}
							и{' '}
							<a
								href={userAgreementDocument.url}
								className="text-accent hover:underline"
								target="_blank"
							>
								Пользовательского соглашения
							</a>{' '}
							и даю свое{' '}
							<a
								href={consentOfProcessingPersonalDataDocument.url}
								className="text-accent hover:underline"
								target="_blank"
							>
								согласие на обработку персональных данных
							</a>
						</>
					}
					invalid={!!state?.errors?.confirmPolicy}
					defaultChecked={!!state.formData?.get('confirmPolicy')}
					labelSize="xs"
				/>
				<Checkbox
					name="confirmOffert"
					value="true"
					label={
						<>
							Я согласен с условиями{' '}
							<a
								href={ofertaDocument.url}
								className="text-accent hover:underline"
								target="_blank"
							>
								Оферты
							</a>
						</>
					}
					invalid={!!state?.errors?.confirmOffert}
					defaultChecked={!!state.formData?.get('confirmOffert')}
					labelSize="xs"
				/>
			</fieldset>

			<Button type="submit" size="lg" loading={pending} block>
				Продолжить
			</Button>
		</form>
	);
}
